var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 138,
    viewBox: "0 0 157 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.253 75.8002C142.253 109.844 114.654 137.443 80.6106 137.443C46.5668 137.443 18.9688 109.844 18.9688 75.8002C18.9688 41.7564 46.5668 14.1577 80.6106 14.1577C114.654 14.1577 142.253 41.7564 142.253 75.8002Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.828738,
    strokeDasharray: "4.16 4.16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.38 75.7999C126.38 101.081 105.885 121.576 80.6036 121.576C55.3218 121.576 34.8281 101.081 34.8281 75.7999C34.8281 50.5188 55.3218 30.0239 80.6036 30.0239C105.885 30.0239 126.38 50.5188 126.38 75.7999Z",
    stroke: "#C4C3C3",
    strokeWidth: 0.828738,
    strokeDasharray: "4.18 4.18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31635 84.1L6.17188 84.0649",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49267 81.9287L5.67188 82.6955",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35316 80.938L4.33594 82.0569",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14844 81.7065L2.94547 82.5226",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17188 83.7842L2.31576 83.8192",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 85.9547L2.82139 85.188",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13281 86.9451L4.15004 85.8262",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34391 86.1769L5.54688 85.3608",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.573 68.1465L156.07 68.6911",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.203 68.6201L154.583 68.9699",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.82 71.0339L154.323 70.4893",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M156.184 70.5603L155.805 70.2104",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.498 4.13667L109.281 4.104",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.347 1.19922L107.328 2.23916",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.953 3.84473L105.17 3.8768",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.109 6.78311L107.128 5.74316",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3763 116.423C19.5008 116.685 18.0428 117.971 17.5439 119.496C17.4602 118.079 16.5604 116.298 15.5703 116.042C16.7783 115.615 18.0867 114.045 18.4348 112.722C18.3718 114.108 19.6303 116.121 20.3763 116.423Z",
    fill: "#D8D8D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8828 9.70775C40.2075 9.82713 39.0108 10.6586 38.5071 11.7514C38.5671 10.6889 38.051 9.28429 37.3359 9.00752C38.2725 8.79371 39.3832 7.73773 39.7567 6.78271C39.5898 7.81019 40.353 9.41851 40.8828 9.70775Z",
    fill: "#D8D8D8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.379 17.4229C129.477 17.4033 128.761 16.6567 128.782 15.7551C128.801 14.8536 129.548 14.1385 130.449 14.1581C131.351 14.1777 132.066 14.9243 132.046 15.8258C132.026 16.7274 131.28 17.4425 130.379 17.4229Z",
    fill: "#D1D9E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.391 124.419C129.606 124.402 128.984 123.752 129 122.967C129.017 122.182 129.667 121.56 130.452 121.576C131.238 121.594 131.86 122.243 131.843 123.029C131.826 123.813 131.176 124.436 130.391 124.419Z",
    fill: "#D8D8D8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3452 39.0935C11.8594 39.0828 11.4739 38.6807 11.4846 38.1943C11.4947 37.7085 11.8974 37.3236 12.3832 37.3337C12.869 37.3444 13.2545 37.7465 13.2444 38.2323C13.2337 38.7187 12.831 39.1042 12.3452 39.0935Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.828738,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1764 63.375C84.2929 63.375 86.8201 65.8539 86.8201 68.9124C86.8193 69.7163 86.6418 70.5103 86.3001 71.238C85.9583 71.9657 85.4608 72.6094 84.8426 73.1234C85.1073 73.2519 85.3478 73.3813 85.5652 73.5117C86.0337 73.7919 86.5197 74.1397 87.0239 74.5541C87.092 74.6093 87.1483 74.6776 87.1895 74.7549C87.2307 74.8322 87.2561 74.917 87.264 75.0042C87.2719 75.0915 87.2623 75.1794 87.2356 75.2629C87.209 75.3464 87.1659 75.4237 87.1089 75.4902C86.9921 75.6259 86.827 75.7105 86.6486 75.726C86.4703 75.7415 86.293 75.6867 86.1545 75.5733C85.7464 75.2328 85.3137 74.9228 84.86 74.6459C84.4175 74.3884 83.9578 74.1615 83.4843 73.9667C82.7567 74.2867 81.9703 74.4512 81.1755 74.4498C80.2997 74.4513 79.4354 74.2513 78.6493 73.8653L78.6087 73.8846C76.6988 74.615 75.3048 75.695 74.4064 77.1286C73.5031 78.5671 73.1341 80.1746 73.2993 81.9724C73.3064 82.0601 73.2962 82.1483 73.2691 82.232C73.2421 82.3158 73.1988 82.3933 73.1417 82.4603C73.0846 82.5272 73.0149 82.5823 72.9365 82.6222C72.8581 82.6621 72.7726 82.6862 72.6849 82.6931C72.5077 82.7103 72.3308 82.6567 72.193 82.5439C72.0553 82.4311 71.9678 82.2683 71.9497 82.0912C71.7594 80.0123 72.1941 78.1179 73.2519 76.4321C74.1832 74.9483 75.5511 73.7948 77.3383 72.9727C76.7699 72.4599 76.3155 71.8336 76.0043 71.1342C75.6931 70.4348 75.5322 69.6779 75.5318 68.9124C75.5318 65.8539 78.06 63.375 81.1764 63.375ZM88.1542 77.1315C88.2799 77.0073 88.4493 76.9375 88.626 76.9369C88.8027 76.9364 88.9725 77.0052 89.099 77.1286C89.3598 77.3856 89.3598 77.8029 89.1009 78.0609L87.9494 79.1998L89.1009 80.3398C89.1627 80.4006 89.2118 80.4732 89.2452 80.5532C89.2786 80.6332 89.2957 80.7191 89.2955 80.8058C89.2954 80.8925 89.2779 80.9783 89.2441 81.0582C89.2104 81.1381 89.161 81.2105 89.099 81.271C88.9728 81.3947 88.8031 81.4639 88.6264 81.4637C88.4497 81.4635 88.2802 81.394 88.1542 81.2701L87.0075 80.133L85.8608 81.2701C85.7483 81.3807 85.6005 81.4483 85.4432 81.4612C85.2859 81.4741 85.1291 81.4314 85.0001 81.3406L84.917 81.271C84.8549 81.2105 84.8056 81.1381 84.7718 81.0582C84.7381 80.9783 84.7206 80.8925 84.7204 80.8058C84.7203 80.7191 84.7374 80.6332 84.7708 80.5532C84.8042 80.4732 84.8532 80.4006 84.915 80.3398L86.0646 79.1998L84.915 78.0599C84.8532 77.9991 84.8042 77.9265 84.7708 77.8465C84.7374 77.7665 84.7203 77.6806 84.7204 77.5939C84.7206 77.5071 84.7381 77.4213 84.7718 77.3414C84.8056 77.2616 84.8549 77.1892 84.917 77.1286C85.0433 77.0054 85.2128 76.9366 85.3893 76.9369C85.5657 76.9373 85.735 77.0068 85.8608 77.1306L87.0075 78.2666L88.1542 77.1315ZM81.1764 64.7033C78.8067 64.7033 76.8872 66.5871 76.8872 68.9114C76.8872 71.2357 78.8067 73.1205 81.1764 73.1205C83.5452 73.1205 85.4657 71.2367 85.4657 68.9114C85.4657 66.5871 83.5452 64.7033 81.1764 64.7033Z",
    fill: "#D92217"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUser);
export default __webpack_public_path__ + "static/media/delete_user.6d2f72da401dca0c15b0b290ed1aa59d.svg";
export { ForwardRef as ReactComponent };